<template>    
    <BaseModal
        :id="'static-assignment'"
        :title="title"
        :size="'lg'"
        :message="'Use this modal to assign daily assignments or a day off to an employee. Make sure to save before closing this modal.'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div v-if="view_by_associate">
                <div class="alert alert-warning mt-2 p-2" role="alert" v-if="local_object.repeated_assignments_associate && local_object.repeated_assignments_associate.length">
                    This associate has been assigned daily assignment(s) to this date on the master(s) days off named: <br />
                    <span v-for="(item,index) in local_object.repeated_assignments_associate" :key="index">
                        <a   :href="`days-off-templates?schedule_id=${item.rotation_setup_id}`" v-html="item.description" />
                        {{ ((index + 1) != local_object.repeated_assignments_associate.length) ? '-' : ''  }}
                    </span>
                </div>

                <div class="alert alert-info mt-2 p-2" role="alert" v-if="local_object.repeated_time_offs && local_object.repeated_time_offs.length">
                    This associate has been assigned a time off to this date on the master(s) days off named: <br />
                    <span v-for="(item,index) in local_object.repeated_time_offs" :key="index">
                        <a   :href="`days-off-templates?schedule_id=${item.rotation_setup_id}`" v-html="`${item.description}`" />
                        {{ ((index + 1) != local_object.repeated_time_offs.length) ? '-' : ''  }}
                    </span>
                </div>

                <form class="col-12 p-0" @submit.prevent="form_submit_update()">
                    <div class="p-0 formdynamic__item" :style="`margin-top:20px`" v-if="Object.keys(single_object).length">
                            <div class="formdynamic__item__field" id="multiselect__schedule">
                                <label v-html="label_form" class="modal-label mb-1" :for="`assignment`"/>
                                <multiselect @select="getRepeatedAssignments()" @remove="getRepeatedAssignments()" v-if="!time_off" v-model="local_object.assignments"  :options="array_options.daily_assignment_id" :multiple="true" :close-on-select="false" :clear-on-select="false" :taggable="true" :preserve-search="true" placeholder="Select daily assignments" label="name" track-by="name" :preselect-first="false">
                                    <!-- <template slot="selection" slot-scope="{ values }"><span class="multiselect__single" v-if="values.length" >{{ values.length }} daily assignment{{ values.length > 1  ? 's' : ''}}  selected</span></template> -->
                                </multiselect>
                                <multiselect  v-else name="time-off" v-model="local_object.assignments"  :options="array_options.time_off_id" :multiple="false" :close-on-select="true" :clear-on-select="false"  :preserve-search="true" placeholder="Select time off" label="description" track-by="id" :preselect-first="false">
                                </multiselect>
                            </div>
                            
                        </div>
                        <span class="custom-control custom-checkbox mt-3">
                            <input 
                                type="checkbox" 
                                class="custom-control-input"
                                id="time-off"
                                v-model="time_off"
                            />
                            <label
                                class="custom-control-label ml-2"
                                for="time-off" v-html="'Time Off'"/>
                        </span>
                        <div class="col-md-12 col-sm-12" v-if="repeated_assignments_associate.length && !time_off">
                            <div class="alert alert-danger p-2" role="alert">This associate already has the following assignments scheduled for this day. Please make corrections to proceed.</div>
                            <div style="margin-top: -10px" class="w-100 table-responsive defaultproject__table overflow-y table-fix-head" :style="`max-height: 13.3rem`">
                                <table class="table animate__animated animate__fadeIn animate__fast">
                                    <thead style="background-color: #fff">
                                        <tr>
                                        <th style="font-weight: normal !important"  class="header-item-manual" v-html="'Daily Assignment'"/>
                                        <th style="font-weight: normal !important"  class="header-item-manual" v-html="'Rotation'"/>
                                        <th v-if="viewing_schedule == 3" style="font-weight: normal !important"  class="header-item-manual" v-html="'Start Date'"/>

                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        <template>
                                        <tr v-for="(item, index) in repeated_assignments_associate" :key="index">
                                            <td v-html="item.daily_assignment" />
                                            <td>
                                                <a :href="`days-off-templates?schedule_id=${item.rotation_setup_id}`" v-html="item.description" />
                                            </td>
                                        </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-if="repeated_assignments.length && !time_off">
                            <div class="alert alert-danger mt-4 p-2" role="alert">The following associates are assigned to some of the selected assignments for this day</div>
                            <div style="margin-top: -10px" class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head" :style="`max-height: 13.3rem`">
                                <table class="table animate__animated animate__fadeIn animate__fast">
                                    <thead style="background-color: #fff">
                                        <tr>
                                        <th style="font-weight: normal !important"  class="header-item-manual" v-html="'Associate'"/>
                                        <th style="font-weight: normal !important"  class="header-item-manual" v-html="'Daily Assignment'"/>
                                        <th style="font-weight: normal !important"  class="header-item-manual" v-html="'Rotation'"/>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        <template>
                                        <tr v-for="(item, index) in repeated_assignments" :key="index">
                                            <td v-html="item.associate_name" />
                                            <td v-html="item.daily_assignment" />
                                            <td>
                                                <a :href="`days-off-templates?schedule_id=${item.rotation_setup_id}`" v-html="item.description" />
                                            </td>
                                        </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    <CentralLiteButtons />
                </form>
            </div>
            <div v-else>
                <form class="col-12 p-0" @submit.prevent="form_submit_update()">
                    <div class="p-0 formdynamic__item" :style="`margin-top:20px`" v-if="Object.keys(single_object).length">
                            <div class="formdynamic__item__field" id="multiselect__schedule">
                                <label v-html="'Daily Assignment'" class="modal-label mb-1" :for="`assignment`"/>
                                <multiselect 
                                    v-model="selected_option"  
                                    :options="array_options.daily_assignment_id" 
                                    placeholder="Select a daily assignment" 
                                    label="name" 
                                    track-by="name" 
                                />
                            </div>
                        </div>
                    <CentralLiteButtons />
                </form>
            </div>
        </template>
    </BaseModal>
</template>

<script>

import Multiselect  from    "vue-multiselect"
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralLiteButtons  from '@/components/CentralLiteButtons'

export default {

    name:   'UpdateModal',
    props: [
        'rest_api',
        'parent_rest_api',
        'notyf',
        'indexes',
        "array_options",
        "breadcrumb",
        "view_by_associate",
        "parent",
        "templates"
    ],

    components:{
        Multiselect,
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            title: '',
            daily_assignments: [],
            selected_option: {id: null, name: null},
            time_off: null,
            label_form: '',
            options: [],
            single_object: {},
            local_object: {},
            originally_time_off: null,
            repeated_assignments: [],
            repeated_assignments_associate: [],
        }
    },
    
    methods:{

        async form_submit_update()
        {
            this.loader(true)

            if(this.time_off && this.local_object.assignments)
            {
                this.local_object.assignments['is_time_off'] = this.time_off;
                this.local_object.assignments = [this.local_object.assignments]
            }

            let http_object = {}

            if(this.view_by_associate)
            {
                http_object = {
                    rotation_id: this.parent.id,
                    template_id: this.templates[this.indexes.row_index].id,
                    local_object: this.local_object,
                    view_by_associate: true
                }
            }
            else
            {
                http_object = {
                    rotation_id: this.parent.id,
                    template_id: this.templates[this.indexes.row_index].id,
                    local_object: this.local_object,
                    daily_assignment_id:  this.templates[this.indexes.row_index].daily_assignment_id,
                    new_daily_assignment_id: this.selected_option.id,
                    view_by_associate: false
                }
            }

            const response = await this.patch(`${this.rest_api}/${this.single_object.id}`, http_object)

            if(response.status)
            {
                this.repeated_assignments_associate = []
                let response_object = {
                    template_index: this.template_index,
                    schedule_index: this.schedule_index,
                    template_object: response.data.data,
                }
                this.$emit('spliceObject', response_object)
                this.notyf.success(`Success!`)
                this.loader()
            } 
            else
            {
                this.repeated_assignments_associate = response.data.repeated_assignments;
                this.error_handling('Check the errors and try again')
                this.loader()
            }
        },

        reset(param, single_object, date_for_backend)
        {
            this.time_off = param
            this.originally_time_off = param
            this.single_object = {...single_object, date_for_backend}
            this.local_object = {...this.single_object}

            if(!this.view_by_associate)
            {
                /*
                * Due to a bug on the multiselect with references I need kind of reset the list of options before giving a new value to its v-model variable
                */

                let backup_assignments                 = JSON.stringify(this.array_options.daily_assignment_id)
                this.array_options.daily_assignment_id = null;
                this.array_options.daily_assignment_id = JSON.parse(backup_assignments);

                this.selected_option.id     = this.local_object.daily_assignment_id
                this.selected_option.name   = this.local_object.daily_assignment
            }
            else
            {
                this.getRepeatedAssignments()
            }
        },

        async getRepeatedAssignments()
        {
             setTimeout(async () => 
             {
                const http_object =
                {
                    rotation_day_id: this.local_object.id,
                    assignments: this.local_object.assignments,
                    associate_id: this.templates[this.indexes.row_index].associate_id

                }

                const response = await this.post(`${this.parent_rest_api}/repeated_assignments`, http_object)

                if(response.status)
                {
                    this.repeated_assignments = response.data
                }
                else
                {
                    this.error_handling(response)
                }

            }, 1);
        },
    },

    watch: 
    {
        time_off(val)
        {
            if(val)
            {
                this.title = 'Set Time Off'
                this.label_form = 'Time Off'

                if(!this.originally_time_off)
                {
                    this.local_object.assignments = null
                }
                else
                {
                    this.local_object = {...this.single_object}
                }
            }
            else
            {
                this.title = 'Set Daily Assignment'
                this.label_form = 'Daily Assignment'

                if(this.originally_time_off)
                {
                    this.local_object.assignments = []
                }
                else
                {
                    this.local_object = {...this.single_object}
                }
            }


        }
    },

    mounted(){

    }
    
}
</script>